import type { OrchestratedAuctionListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import {
  BidStatus,
  contractByListingIdQuery,
} from '@b-stock/fe-core/bstock-next/queries'
import { usePollUntil } from '@b-stock/fe-core/pay-ui'

export const useExecutedContractIfContractListing = ({
  listing,
  accountId,
  bidState,
  isContract,
}: {
  listing: Pick<OrchestratedAuctionListingDetails, '_id'>
  accountId: string | undefined
  bidState: BidStatus
  isContract?: boolean
}) => {
  const shouldHaveExecutedContract = bidState === BidStatus.WON && !!isContract

  const { data: executedContract, refetch: refetchContract } =
    contractByListingIdQuery.useWithOpts([listing._id, accountId, 'buyer'], {
      enabled: shouldHaveExecutedContract,
    })

  const isExecutedContract = executedContract?.buyerAccountId

  // If we've attempted to lookup an executed contract, but didn't get one, poll every 2s
  usePollUntil(
    refetchContract,
    (contract) => !!contract.data?.buyerAccountId,
    2000,
    shouldHaveExecutedContract && !isExecutedContract
  )

  return { contract: executedContract }
}
